// commonUtils.js
import {
  mdiArrowRight,
  mdiMagnify,
  mdiChevronRight,
  mdiChevronDown,
  mdiPin,
  mdiLock,
  mdiClose,
  mdiDrag,
  mdiAccountKey,
  mdiRefresh,
  mdiDownload,
  mdiArrowRightDropCircleOutline
} from "@mdi/js";

const iconMap = {
  mdiArrowRight,
  mdiMagnify,
  mdiChevronRight,
  mdiChevronDown,
  mdiPin,
  mdiLock,
  mdiClose,
  mdiDrag,
  mdiAccountKey,
  mdiRefresh,
  mdiDownload,
  mdiArrowRightDropCircleOutline
};

export default {
  install(Vue) {
    Vue.config.globalProperties.$iconPath = function (icon) {
      return iconMap[icon] || iconMap["mdiMagnify"];
    };
  },
};